// Module
var code = "<td> <formly-transclude></formly-transclude> </td>";
// Exports
var _module_exports = code;;
var path = 'ui-formly/wrappers/tableCell/index.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;